/**
 * Please create a Javascript function called TealiumConsentPrivacyLink() that redirects the user to the correct Privacy Policy Page.
 * We'll then create the link <a href="javascript:TealiumConsentPrivacyLink()">Privacy Policy</a>
 */
function TealiumConsentPrivacyLink() {
    window.location.href = window.routes.root_url + '/pages/privacy-policy';
}

/**
 * Please create a Javascript function called TealiumTermsOfUseLink() that redirects the user to the correct Terms of Use Page.
 * We'll then create the link <a href="javascript:TealiumTermsOfUseLink()">Terms of use</a>
 */
function TealiumTermsOfUseLink() {
    window.location.href = window.routes.root_url + '/pages/terms-of-use';
}

/**
 * Please create a Javascript function called TealiumConsentFormLink() that redirects the user to the correct Response Form (e.g. for Vogue is http://e.luxottica.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DYQpglLjHJlYQGiTj6Jf39g6LiOsKzfWrBHmzfH7zgOyr7RzcCo3VXMtX%3DYQpglLjHJlYQGszfSrLdLe9CMNg7pdfEzdfh47Wn8CB3JGpq3&_ei_=EjMUxrCFkVpafqdZyE8bu1s&brand=VG&lang=EN&SourceOrigin=WebApp)
 * We’ll then use the function to include the link in the Consent Manager text.
 */
function TealiumConsentFormLink() {
    window.location.href = window.routes.root_url + '/pages/contact-us';
}

/**
 * Tealium tracks clicks for <a</a> elements automatically but not for <summary> elements.
 * Using Dawn's <details-modal> component for the main navigation we need to track clicks on the <summary> element.
*/
document.addEventListener('mousedown', (e) => {
    const summaryElement = e.target.closest('summary[data-element-id]');
    if (summaryElement) {
        const dataElementID = summaryElement.getAttribute('data-element-id');
        Fetchutils.sendTealiumData({
            'id': 'Click',
            'data_element_id': dataElementID
        });
    }

    /**
     * [ISRC] Internal Search:
     * All clicks on anchors inside the search panel box should be tracked using hiddenaction Tracking_Type
     */
    const hiddenActionElement = e.target.closest('a[data-element-id]');
    if (hiddenActionElement) {
        const dataElementID = hiddenActionElement.getAttribute('data-element-id') || '';
        const dataDescription = hiddenActionElement.getAttribute('data-description') || '';

        Fetchutils.sendTealiumData({
            'id': 'Click',
            'Tracking_Type': 'hiddenaction',
            'data_element_id': dataElementID,
            'data_description': dataDescription
        });
    }
});

/**
 * Event handlers for tracking global events with Tealium.
 */
function setupGlobalTealiumEventHandlers() {

    // Filter Applied
    subscribe(PUB_SUB_EVENTS.facetsUpdate, (payload) => {
        Fetchutils.sendTealiumData({
            'id': 'Event',
            ...payload
        });
    });

    // Internal Search Results
    subscribe(PUB_SUB_EVENTS.searchSubmit, (payload) => {
        // Debounce for 2 seconds to wait until user has finished typing
        GeneralUtils.debounce(() => {
            Fetchutils.sendTealiumData({
                'id': 'Event',
                ...payload
            });
        }, 2000)();
    });

    // Add to Cart Success
    document.addEventListener("la:dn:cart:updated", async function(event) {
        const localStorageKey = "discountNinjaItems";
        const localStorageItems = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        const cartItems = event.detail.data[0].items;
        const cartItemsVariantIds = cartItems.map(item => item.product.variantId).sort();
        const localStorageVariantIds = localStorageItems.map(item => item.product.variantId).sort();
        let lastAddedProductKey;

        await fetch(`${Shopify.routes.root}cart.js`).then(res => res.json()).then(data => {
            if (!data || !data.items || data.items.length === 0) return;
            lastAddedProductKey = data.items[0].key;
        })

        if (JSON.stringify(cartItemsVariantIds) === JSON.stringify(localStorageVariantIds)) return;
        const lastAddedProduct = cartItems.find(item => item.key === lastAddedProductKey);
        if (!lastAddedProduct) return;
        localStorage.setItem(localStorageKey, JSON.stringify(cartItems));

        // Get product UPC
        if (!window.tealiumTrackingUtils?.mappingVariantIdsUpcs) return;
        let productUPC = window.tealiumTrackingUtils.mappingVariantIdsUpcs[lastAddedProduct.product?.variantId];
        if (!productUPC) productUPC = lastAddedProduct.product?.sku;

        const payload = {
            id: "Event",
            Events_CartAdd: "1",
            Products: {
                [productUPC]: {
                    Status: lastAddedProduct.product?.available ? "Available" : "Out-of-stock",
                    LensType: lastAddedProduct.properties.filter(prop => prop.name === "_itemsRelationshipId").length > 0 ? "RX" : "PLANO",
                    Price: `${(lastAddedProduct.price?.product?.discounted/100)?.toFixed(2)}` || `${(lastAddedProduct.price?.product?.original/100).toFixed(2)}`,
                    PriceFull: `${(lastAddedProduct.price?.product?.original/100)?.toFixed(2)}`,
                    Units: `${lastAddedProduct.quantity}`
                }
            }
        }

        Fetchutils.sendTealiumData(payload);
    });

    // Add to Favorites Success
    subscribe(PUB_SUB_EVENTS.wishlistAdd, (payload) => {
        Fetchutils.sendTealiumData({
            'id': 'Event',
            ...payload
        });
    });

    // Newsletter signup Success
    subscribe(PUB_SUB_EVENTS.newsletterSubscription, (payload) => {
        Fetchutils.sendTealiumData({
            'id': 'Event',
            ...payload
        });
    });

    // dispatch custom event
    document.dispatchEvent(new CustomEvent('tealiumListenersLoaded'));
}

/**
 * Account Creation Tracking
 */
function checkAccountCreation() {
    const isNewAccount = localStorage.getItem('is-account-new') === 'true' ? true : false;
    if (!isNewAccount) return;

    Fetchutils.sendTealiumData({
        'id': 'Event',
        'Events_UserAccountNew': '1',
        'Page_Type': 'Static',
        'Events_UserEmailSub': window.tealiumTrackingUtils.customer.acceptsMarketing ? '1' : '0',
        'Page_Section1': 'Account',
        'Page_Country': window.tealiumTrackingUtils.pageCountry,
        'Order_Currency': window.tealiumTrackingUtils.orderCurrency,
        'User_LoginStatus': 'Logged',
        'User_LoginType': 'Standard',
        'User_Email_MD5': window.tealiumTrackingUtils.customer.emailMd5,
        'User_Email_SHA256': window.tealiumTrackingUtils.customer.emailSha256,
        'User_Id': window.tealiumTrackingUtils.customer.id
    });

    localStorage.setItem('is-account-new', false);

    // Create customer access token
    if (sessionStorage.getItem('customerAccessToken')) {
        localStorage.removeItem('c_profile');
    } else {
        createCustomerAccessToken();
    }
}

/**
 * User Login Tracking
 */
function checkUserLogin() {
    const isUserLogin = localStorage.getItem('is-user-login') === 'true';
    if (!isUserLogin) return;

    Fetchutils.sendTealiumData({
        'id': 'Event',
        'Events_UserLogin': '1',
        'User_LoginStatus': 'Logged',
        'User_LoginType': 'Standard',
        'User_Id': window.tealiumTrackingUtils.customer.id,
        'User_Email_MD5': window.tealiumTrackingUtils.customer.emailMd5,
        'User_Email_SHA256': window.tealiumTrackingUtils.customer.emailSha256
    });

    localStorage.removeItem('is-user-login');
}

/**
 * Creates a customer access token using the stored customer profile data.
 */
async function createCustomerAccessToken() {
    if (!localStorage.getItem('c_profile')) return;
    const storefrontUrl = window.storefront?.url;
    const storefrontToken = window.storefront?.token;

    // Retrieve customer data
    const encodedString = localStorage.getItem('c_profile');
    const decodedString = atob(encodedString);
    const dataObj = JSON.parse(decodedString);

    const input = {
        email: dataObj[0].e,
        password: dataObj[0].p
    }

    try {
        const response = await fetch(storefrontUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storefrontToken
            },
            body: JSON.stringify({
                query: `#graphql
                        mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
                            customerAccessTokenCreate(input: $input) {
                                customerAccessToken {
                                    accessToken
                                }
                                customerUserErrors {
                                    message
                                }
                            }
                        }
                    `,
                variables: { input }
            })
        });

        const result = await response.json();
        const token = result.data?.customerAccessTokenCreate?.customerAccessToken;

        if (result.error) {
            console.error(result.error);
        }

        if (token) {
            sessionStorage.setItem("customerAccessToken", token.accessToken);
            localStorage.removeItem('c_profile');
        }
    }
    catch (error) {
        console.error(error);
    }
}

/**
 * Tealium products tracking utilities.
 */
class TealiumProductsTrackingUtils {
    constructor() {
        if (typeof discountNinja === 'undefined' || typeof discountNinja.api === 'undefined') {
            document.addEventListener("la:dn:api:ready", this.register.bind(this));
        } else {
            this.register();
        }
    }

    /**
     * Registers event listeners for Discount Ninja events to update product pricing information.
     */
    register() {
        if (window.tealiumTrackingUtils?.template !== 'cart') {
            /* PLP/PDP discounts */
            document.addEventListener("la:dn:product:discount:calculated", (ev) => {
                try {
                    const productUpc = (window.tealiumTrackingUtils.pageType === 'Pdp' && info.variantId == window.tealiumTrackingUtils.currentVariantId) ? window.tealiumTrackingUtils.currentProductUpc : this.getProductUpcFromVariantId(info.variantId);
                    if (productUpc) {
                        const info = ev.detail.data[0];
                        let originalPrice = this.centsToNumber(info.originalPrice);
                        let discountedPrice = this.centsToNumber(info.discountedPrice);
                        let discountAmount = this.centsToNumber(info.amount);
                        originalPrice = (typeof originalPrice === 'number') ? originalPrice.toFixed(2) : originalPrice;
                        discountedPrice = (typeof discountedPrice === 'number') ? discountedPrice.toFixed(2) : discountedPrice;
                        discountAmount = (typeof discountAmount === 'number') ? discountAmount.toFixed(2) : discountAmount;
                        const discountPercent = info.percentage;
                        const offerToken = info.offerToken || null;
                        const promotionToken = info.promotionToken || null;
                        const discountCode = info.discountCode || null;
                        const isDiscountedByOffer = !!info.isDiscountedByOffer;

                        this.updateProductObjectPricingFromDN(
                            productUpc,
                            originalPrice,
                            discountedPrice,
                            discountAmount,
                            discountPercent,
                            offerToken,
                            promotionToken,
                            discountCode,
                            isDiscountedByOffer
                        )
                    }
                } catch (e) { /* noop */
                }
            });
        } else {
            /* Cart discounts */
            document.addEventListener("la:dn:cart:updated", (ev) => {
                console.log(ev.detail.data);
                try {
                    const items = ev.detail.data[0].items || [];
                    // Since the cart object does not specify which promotion is applied by DN, we check if any of the applied promotions are from native discounts.
                    // If not, we assume the discount is applied by DN offer.
                    const isDiscountedByNativeDiscount = ev.detail.data[0].appliedPromotions?.some(promo => promo.source === "native") || false;
                    for (const item of items) {
                        const productUpc = this.getProductUpcFromVariantId(item.product.variantId);
                        if (productUpc) {
                            let originalPrice = this.centsToNumber(item.price.line.original);
                            let discountedPrice = this.centsToNumber(item.price.line.discounted);
                            let discountAmount = this.centsToNumber(item.discount.line.amount);
                            originalPrice = (typeof originalPrice === 'number') ? originalPrice.toFixed(2) : originalPrice;
                            discountedPrice = (typeof discountedPrice === 'number') ? discountedPrice.toFixed(2) : discountedPrice;
                            discountAmount = (typeof discountAmount === 'number') ? discountAmount.toFixed(2) : discountAmount;
                            const discountPercent = item.discount.line.percentage;
                            const offerToken = item.appliedPromotion.offerToken || null;
                            const promotionToken = item.appliedPromotion.promotionToken || null;
                            const discountCode = item.appliedPromotion.discountCode || null;
                            const isDiscountedByOffer = !isDiscountedByNativeDiscount;

                            this.updateProductObjectPricingFromDN(
                                productUpc,
                                originalPrice,
                                discountedPrice,
                                discountAmount,
                                discountPercent,
                                offerToken,
                                promotionToken,
                                discountCode,
                                isDiscountedByOffer
                            )
                        }
                    }
                } catch (e) { /* noop */
                }
            });
        }
    }

    /**
     * Updates the product object pricing information based on Discount Ninja data.
     * @param {*} productUpc - The UPC of the product.
     * @param {*} originalPrice - The original price of the product.
     * @param {*} discountedPrice - The discounted price of the product.
     * @param {*} amount - The discount amount.
     * @param {*} percentage - The discount percentage.
     * @param {*} offerToken - The offer token.
     * @param {*} promotionToken - The promotion token.
     * @param {*} discountCode - The discount code.
     * @param {*} isDiscountedByOffer - Whether the product is discounted by a DN offer.
     */
    updateProductObjectPricingFromDN(productUpc, originalPrice, discountedPrice, amount, percentage, offerToken, promotionToken, discountCode, isDiscountedByOffer) {
        var p = window.tealiumTrackingUtils.products[productUpc] || (window.tealiumTrackingUtils.products[productUpc] = {});

        this.setIf(p, 'Price', discountedPrice);
        this.setIf(p, 'PriceNet', discountedPrice);
        this.setIf(p, 'PriceFull', originalPrice);
        this.setIf(p, 'PriceFullNet', originalPrice);
        this.setIf(p, 'PriceOriginalDN', originalPrice);
        this.setIf(p, 'PriceDiscounted', discountedPrice);
        this.setIf(p, 'DNDiscountAmount', amount);
        this.setIf(p, 'DNDiscountPercent', percentage);
        this.setIf(p, 'DNOfferToken', offerToken);
        this.setIf(p, 'DNPromotionToken', promotionToken);
        this.setIf(p, 'DNDiscountCode', discountCode);
        this.setIf(p, 'DNIsDiscountedByOffer', isDiscountedByOffer);
    }

    /**
     * Gets the product UPC from the variant ID using the global mapping. (defined in tealium-products.liquid)
     * @param {*} variantId - The variant ID.
     * @returns The product UPC or null if not found.
     */
    getProductUpcFromVariantId(variantId) {
        if (!window.tealiumTrackingUtils?.mappingVariantIdsUpcs) return null;

        const upc = window.tealiumTrackingUtils.mappingVariantIdsUpcs[variantId];
        return upc || null;
    }

    /**
     * Converts cents to a number.
     * @param {*} c - The cents value.
     * @returns The number value or null if input is not a number.
     */
    centsToNumber(c) {
        return (typeof c === 'number') ? (Math.round(c) / 100) : null;
    }

    /**
     * Sets the value of a key in an object if the value is not null or undefined.
     * @param {*} obj - The object to set the value in.
     * @param {*} key - The key to set.
     * @param {*} val - The value to set.
     */
    setIf(obj, key, val) {
        if (val !== null && val !== undefined) obj[key] = val;
    }
}

/**
 * Tealium page view tracking utilities.
 */
class TealiumPageViewTrackingUtils {
    constructor() {
        this.trackPageView();
    }

    trackPageView() {
        if (!window.tealiumTrackingUtils) return;
        const tealiumPayload = {}

        // Common data
        this.setIf(tealiumPayload, 'Page_Type', window.tealiumTrackingUtils.pageType);
        this.setIf(tealiumPayload, 'Page_Section1', window.tealiumTrackingUtils.pageSection1);
        this.setIf(tealiumPayload, 'Page_Section2', window.tealiumTrackingUtils.pageSection2);
        this.setIf(tealiumPayload, 'Page_Section3', window.tealiumTrackingUtils.pageSection3);
        this.setIf(tealiumPayload, 'Page_Country', window.tealiumTrackingUtils.pageCountry);
        this.setIf(tealiumPayload, 'Order_Currency', window.tealiumTrackingUtils.orderCurrency);
        this.setIf(tealiumPayload, 'lang', window.tealiumTrackingUtils.lang);

        // User data
        this.setIf(tealiumPayload, 'User_LoginStatus', window.tealiumTrackingUtils.userLoginStatus);
        this.setIf(tealiumPayload, 'User_LoginType', window.tealiumTrackingUtils.userLoginType);
        this.setIf(tealiumPayload, 'User_Email_MD5', window.tealiumTrackingUtils.customer?.emailMd5);
        this.setIf(tealiumPayload, 'User_Email_SHA256', window.tealiumTrackingUtils.customer?.emailSha256);
        this.setIf(tealiumPayload, 'User_Id', window.tealiumTrackingUtils.customer?.id);

        // Products Object data
        this.setIf(tealiumPayload, 'Products', window.tealiumTrackingUtils.products);

        // Cart, Checkout, Order data
        this.setIf(tealiumPayload, 'Order_DiscountName', window.tealiumTrackingUtils.discountTitles);
        this.setIf(tealiumPayload, 'Order_DiscountAmount', window.tealiumTrackingUtils.totalDiscounts);
        this.setIf(tealiumPayload, 'Order_DiscountAmountNet', window.tealiumTrackingUtils.totalDiscounts);

        // Internal Search & Prod Listing data
        if (window.tealiumTrackingUtils.template == 'collection') {
            this.setIf(tealiumPayload, 'Search_ResultItemsQnt', window.tealiumTrackingUtils.searchResultItemsQnt);
            this.setIf(tealiumPayload, 'Search_FacetValues_String', this.getFacetsValueFromUrl());
        }

        // Errors data
        if (window.tealiumTrackingUtils.eventError) {
            this.setIf(tealiumPayload, 'Events_Error', window.tealiumTrackingUtils.eventError);
            this.setIf(tealiumPayload, 'Error_Source', window.tealiumTrackingUtils.eventSource);
            this.setIf(tealiumPayload, 'Error_Code', window.tealiumTrackingUtils.errorCode);
            this.setIf(tealiumPayload, 'Error_Details', window.tealiumTrackingUtils.errorDetails);
        }

        if (window.tealiumTrackingUtils.template == 'product') {
            subscribe(PUB_SUB_EVENTS.VMMVAvailability, async (payload) => {
                // payload contains Vm_IsUpcSupported and Vm_IsBrowserSupported properties
                Fetchutils.sendTealiumData({
                    'id': 'VirtualPage-View',
                    ...tealiumPayload,
                    ...payload
                });
            });
        }
        // Storefront API PLP
        else if (window.tealiumTrackingUtils.template == 'collection' && window.arnPlpConfig?.engine) {
            subscribe(PUB_SUB_EVENTS.plpProductsLoaded, (payload) => {
                Fetchutils.sendTealiumData({
                    'id': 'VirtualPage-View',
                    ...tealiumPayload,
                    'Products': window.tealiumTrackingUtils.products,
                    'Search_ResultItemsQnt': window.tealiumTrackingUtils.searchResultItemsQnt,
                    ...payload
                });
            });
        }
        else if (window.tealiumTrackingUtils.template === 'cart') {
            // Since cart token is not available on liquid, we need to fetch cart.js
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    if (cart.token) {
                        tealiumPayload.Order_CartId = cart.token;
                        sessionStorage.setItem('cart_token', JSON.stringify(cart.token));
                        Fetchutils.sendTealiumData({
                            'id': 'VirtualPage-View',
                            ...tealiumPayload
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching cart data:', error);
                });
        }
        else {
            Fetchutils.sendTealiumData({
                'id': 'VirtualPage-View',
                ...tealiumPayload
            });
        }
    }

    setIf(obj, key, val) {
        if (val !== null && val !== undefined) obj[key] = val;
    }

    getFacetsValueFromUrl() {
        let searchParams = window.location.search;
        searchParams = new URLSearchParams(searchParams);
        let facetValuesString = [];
        for (const [key, value] of searchParams) {
            if (key !== 'q') facetValuesString.push(`${key}=${value}`);
        }
        return facetValuesString.join('|');
    }
}

/**
 * Initialize Tealium
 */
let tealiumInterval;

function initTealium() {
    if (typeof tealium_data2track !== 'undefined' && typeof tealium_data2track.push === 'function') {
        clearInterval(tealiumInterval);

        if (window.tealiumTrackingUtils?.customer) {
            checkAccountCreation();
            checkUserLogin();
        }
        if (window.tealiumTrackingUtils?.template === 'product' || window.tealiumTrackingUtils?.template === 'collection' || window.tealiumTrackingUtils?.template === 'cart') {
            new TealiumProductsTrackingUtils();
        }
        new TealiumPageViewTrackingUtils();
        setupGlobalTealiumEventHandlers();
    }
}

/**
 * Include Tealium script
 */
function includeTealiumScript() {
    a =
        `//tags.tiqcdn.com/utag/${window.tealiumTrackingUtils?.tealiumAccount}/${window.tealiumTrackingUtils?.tealiumProfile}/${window.tealiumTrackingUtils?.tealiumEnvironment}/utag.js`;
    b = document;
    c = 'script';
    d = b.createElement(c);
    d.src = a;
    d.type = 'text/java' + c;
    d.async = true;
    a = b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d, a);
}

/**
 * Tealium entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    includeTealiumScript();
    tealiumInterval = setInterval(initTealium, 100);
});